export default "__VITE_ASSET__DkiTcqD1__"